// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Review-Home-ReviewMetricsQuestion-ReviewMetricsQuestion-module__percentageDescription";
var _2 = "webpack-containers-Review-Home-ReviewMetricsQuestion-ReviewMetricsQuestion-module__title";
export { _1 as "percentageDescription", _2 as "title" }
